<template>
	<div class="insideBody">
		<div class="infimgList">
			<img src="../../assets/images/wxt1.jpg" />
			<img src="../../assets/images/wxt2.jpg" />
			<img src="../../assets/images/wxt3.jpg" />
			<img src="../../assets/images/wxt4.jpg" />
		</div>
	</div>
</template>
<script>
export default {
  data(){
    return {
			height: null
		};
	},
	created(){
	},
	methods:{
	},
	mounted(){
	},
	components: {
		
	},
}
</script>
<style scoped>
	
</style>